import { render } from "./analyseDetail.vue?vue&type=template&id=687ab799&scoped=true"
import script from "./analyseDetail.vue?vue&type=script&lang=js"
export * from "./analyseDetail.vue?vue&type=script&lang=js"

import "./analyseDetail.vue?vue&type=style&index=0&id=687ab799&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687ab799"]])

export default __exports__